import { Brand } from '../app/shared/interfaces/brand';

export const brands: Brand[] = [
    {image: 'assets/images/logos/logo-1.png'},
    {image: 'assets/images/logos/logo-2.png'},
    {image: 'assets/images/logos/logo-3.png'},
    {image: 'assets/images/logos/logo-4.png'},
    {image: 'assets/images/logos/logo-5.png'},
    {image: 'assets/images/logos/logo-6.png'},
    {image: 'assets/images/logos/logo-7.png'}
];
